import { Component, OnInit } from '@angular/core';
import { DmiSubnavService } from '../dmi-model/services/dmi-subnav.service';

@Component({
  selector: 'app-dmi-tools',
  templateUrl: './dmi-tools.component.html',
  styleUrls: ['./dmi-tools.component.scss']
})
export class DmiToolsComponent implements OnInit {

  orgName = '';
  orgId = '';

  navSelection = 'data';
  subNav?:Array<any>;
  constructor(private menuInfo:DmiSubnavService) { }

  NavClick(target:string) {
    this.navSelection = (this.navSelection === target) ? '' : target;
  }

  ngOnInit(): void {
    this.subNav = (this.menuInfo.GetSubNav('data') as any).default;
    console.log(this.subNav);
  }

}
